module.exports = __webpack_public_path__ + "static/media/Step2.8.9192ac00.png";